query ListOptOutItems(
  $first: Int
  $last: Int
  $after: String
  $before: String
  $query: String
  $queryList: [QueryItemInput!]
) {
  messagingOptoutItems(
    first: $first
    last: $last
    after: $after
    before: $before
    query: $query
    queryList: $queryList
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    edges {
      node {
        id
        insertedAt
        updatedAt
        type
        notes
        remoteNumber
        hostNumber
        tcrBrandId
        tcrCampaignId
        keyword
        metadata

        sms {
          id
        }

        hostDid {
          id
          number
        }

        account {
          id
          name
        }

        cspBrand {
          id
          displayName
        }

        cspCampaign {
          id
          usecase
        }
      }
    }
  }
}
